import React from 'react'
import { HStack, Select, Badge, Tooltip } from '@chakra-ui/react'
import { useMyProfileWithModules } from '../../api/api_hooks/user/myProfile'
import { AVAILABLE_CHU_CONFIGS } from '../../config/chuConfig'
import { getAdminCHUOverride, setAdminCHUOverride } from '../../contexts/CHUConfigContext'

/**
 * Admin-only control: force a specific CHU config (Nancy, Lyon, AP-HP…) to test
 * the app / blot workspace as that CHU. Changing it reloads the page so every
 * config-driven feature (AI access, labels, export…) re-resolves. Hidden for
 * non-admins.
 */
export const AdminCHUSelector: React.FC = () => {
  const { data: profile } = useMyProfileWithModules()
  const isAdmin = profile?.role === 'admin' || profile?.role === 'super_admin'
  if (!isAdmin) return null

  const current = getAdminCHUOverride() ?? ''

  return (
    <HStack spacing={2}>
      <Tooltip label="Admin — forcer une config CHU pour tester (recharge la page)" hasArrow>
        <Select
          size="sm"
          w="230px"
          value={current}
          bg={current ? 'orange.50' : undefined}
          borderColor={current ? 'orange.400' : undefined}
          onChange={(e) => setAdminCHUOverride(e.target.value || null)}
        >
          <option value="">Config de mon organisation</option>
          {AVAILABLE_CHU_CONFIGS.map((c) => (
            <option key={c.key} value={c.key}>Test config : {c.label}</option>
          ))}
        </Select>
      </Tooltip>
      {current && (
        <Badge colorScheme="orange" variant="solid" fontSize="2xs">
          Mode test CHU
        </Badge>
      )}
    </HStack>
  )
}
